import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  // Track language changes
  useEffect(() => {
    setCurrentLang(i18n.language);
  }, [i18n.language]);

  const toggleLanguage = () => {
    const newLang = currentLang === 'ar' ? 'en' : 'ar';
    
    // Update language in i18next
    i18n.changeLanguage(newLang);
    
    // Explicitly save to localStorage
    localStorage.setItem('i18nextLng', newLang);
    
    // Update document properties
    document.dir = newLang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang;
    
    // Update local state
    setCurrentLang(newLang);
    
    // Force page reload to ensure all components update correctly
    window.location.reload();
  };

  return (
    <Button
      variant="outline-light"
      onClick={toggleLanguage}
      className="language-switcher"
      aria-label="Toggle language"
    >
      {currentLang === 'ar' ? 'English' : 'العربية'}
    </Button>
  );
};

export default LanguageSwitcher; 